export const getTimeDisplay = (seconds: number): string => {
  const round = (num: number) => num.toFixed(1);
  if (seconds < 60) return `${round(seconds)} Seconds`;
  const minutes = Math.floor(seconds / 60);
  const newSeconds = seconds % 60;
  return `${minutes} Minute${minutes === 1 ? "" : "s"}, ${round(
    newSeconds
  )} Seconds`;
};
